import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

const HIGHLIGHT_STYLE = 'background-color:#ffeb3b;padding:0;';
const HTML_ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

const escapeHtml = (input) => String(input).replace(/[&<>"']/g, (ch) => HTML_ENTITIES[ch]);
const escapeRegExp = (input) => input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const HighlightText = ({ text, searchTerm }) => {
    const html = useMemo(() => {
        if (text == null || text === '') return '';
        const escapedText = escapeHtml(String(text));

        const rawTerm = typeof searchTerm === 'string' ? searchTerm : String(searchTerm ?? '');
        const trimmed = rawTerm.trim();
        if (!trimmed) return escapedText;

        // Most rendered rows do not contain the term in most of their fields
        // (a row matches on one field but renders up to ~15 HighlightText
        // blocks). A plain substring check is far cheaper than compiling a
        // RegExp and running replace, and returns the identical escaped text.
        const escapedTerm = escapeHtml(trimmed);
        if (!escapedText.toLowerCase().includes(escapedTerm.toLowerCase())) return escapedText;

        const re = new RegExp(`(${escapeRegExp(escapedTerm)})`, 'gi');
        return escapedText.replace(re, `<mark style="${HIGHLIGHT_STYLE}">$1</mark>`);
    }, [text, searchTerm]);

    return (
        <span
            className="notranslate"
            translate="no"
            data-gramm="false"
            data-gramm_editor="false"
            data-enable-grammarly="false"
            data-no-translate="true"
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};

HighlightText.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    searchTerm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(HighlightText);
